import LegalDocumentLayout from "./LegalDocumentLayout";
import LegalPageWithOverride from "./LegalPageWithOverride";
import SeoHead from "@/components/SeoHead";

export default function PrivacyPage() {
  return (
    <>
      <SeoHead route="/privacy" />
      <LegalPageWithOverride
        slug="privacy"
        title="Privacy Policy"
        lastUpdatedFallback="October 7, 2026"
      >
      <LegalDocumentLayout title="Privacy Policy" lastUpdated="October 7, 2026">
      <p>
        Acquigine ("we," "us") respects your privacy. This policy explains
        what information we collect, how we use it, and the rights you have. This page is
        provided for transparency and does not constitute legal advice.
      </p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li><strong>Account information</strong> ,  name, email, password (stored as a bcrypt hash), and role.</li>
        <li><strong>Billing information</strong> ,  subscription tier, payment-processor customer and subscription IDs, and payment status. Full card data is handled directly by our payment processing provider and never touches Acquigine servers.</li>
        <li><strong>Usage data</strong> ,  pages viewed, API calls, feature interactions, and audit logs for security review.</li>
        <li><strong>Content you create</strong> ,  opportunities you add or import, notes, tasks, documents, and outreach messages.</li>
        <li><strong>Integrations you connect</strong> ,  API keys you provide for outbound email, social publishing, e-signature, and similar connected services, stored encrypted-at-rest.</li>
      </ul>

      <h2>2. Data Sources</h2>
      <p>
        Acquigine ingests data from licensed data-enrichment and mapping providers, and from public records and registries maintained by government agencies. Additional licensed sources are evaluated on an ongoing basis and added once ingest is live. We do not scrape sites in violation of their Terms of Service.
      </p>

      <h2>3. How We Use Your Information</h2>
      <ul>
        <li>To operate the service (score opportunities, run outreach sequences, deliver documents).</li>
        <li>To bill you and manage your subscription.</li>
        <li>To send transactional messages, product updates, and ,  for paid tiers ,  the weekly Florida Wind-Down Digest (opt-out available in Settings).</li>
        <li>To detect abuse, prevent fraud, and enforce our Terms of Service.</li>
      </ul>

      <h2>4. Third-Party Processors</h2>
      <p>The following categories of processors receive limited data as required to provide their service:</p>
      <ul>
        <li><strong>Payment processing providers</strong> ,  billing and subscriptions.</li>
        <li><strong>Email delivery providers</strong> ,  transactional email and inbound event capture.</li>
        <li><strong>Outbound email providers</strong> ,  sending from the account you connect.</li>
        <li><strong>E-signature providers</strong> ,  signature envelopes for contracts you initiate.</li>
        <li><strong>Data enrichment and public-record data providers</strong> ,  information about opportunities.</li>
        <li><strong>Social publishing providers</strong> ,  posting on closed deals (opt-in only).</li>
        <li><strong>Mapping and geocoding providers</strong> ,  location lookups.</li>
        <li><strong>Cloud database and hosting providers</strong> ,  encrypted data storage.</li>
      </ul>
      <p>
        A current list of processors is available on written request to <a href="mailto:privacy@acquigine.com">privacy@acquigine.com</a>.
      </p>

      <h2>5. Cookies & Authentication Tokens</h2>
      <p>
        We use a first-party JWT (JSON Web Token) stored in your browser to keep you signed in. We do not use third-party advertising cookies. Session tokens expire and can be revoked by signing out or by an admin.
      </p>

      <h2>6. Data Retention</h2>
      <p>
        Account data is retained while your account is active plus 30 days after cancellation to allow reactivation. You may request full deletion at any time (see below). Audit and payment records may be retained longer where required by law.
      </p>

      <h2>7. Your Rights</h2>
      <p>
        You may request a copy of your data, correction of inaccurate data, or full deletion. Email
        <a href="mailto:privacy@acquigine.com"> privacy@acquigine.com</a> from the address on file and we will respond within 30 days.
      </p>
      <p>
        <strong>California residents (CCPA/CPRA):</strong> you have the right to know what personal information we collect, request deletion, opt out of any "sale" (we do not sell personal information), and be free from retaliation for exercising these rights.
      </p>
      <p>
        <strong>EU/UK residents (GDPR):</strong> you have the right of access, rectification, erasure, restriction, portability, and objection. Our lawful bases are contract performance, legitimate interests, and consent where required.
      </p>

      <h2>8. Security</h2>
      <p>
        Data is encrypted in transit (TLS 1.2+) and at rest. Passwords are salted and bcrypt-hashed. Subscriber API keys are encrypted with AES. Access is role-based; audit logs record admin actions.
      </p>

      <h2>9. Children</h2>
      <p>Acquigine is a professional B2B tool and is not directed to anyone under 18. We do not knowingly collect data from minors.</p>

      <h2>10. Changes</h2>
      <p>We will post material changes here with a new "Last updated" date and, where required, email account owners.</p>

      <h2>11. Contact</h2>
      <p>
        Privacy inquiries: <a href="mailto:privacy@acquigine.com">privacy@acquigine.com</a><br />
        Compliance issues: <a href="mailto:compliance@acquigine.com">compliance@acquigine.com</a><br />
        Legal: <a href="mailto:legal@acquigine.com">legal@acquigine.com</a>
      </p>
    </LegalDocumentLayout>
      </LegalPageWithOverride>
    </>
  );
}
